export const eersteTestvluchtTesten = [
  {
    id: '5da2e789-2322-4dc4-be20-91f4c5f0236c',
    status: 'done',
    time: new Date(),
    result: [
      {
        correct: 4,
        messages: [],
        name: 'Test voor Gordel 1',
        total: 5,
        visibility: 'show',
        children: [
          {
            correct: 1,
            feedback: 'Gordel 1 moet oneindig lang bewegen.',
            messages: [],
            name: 'Juiste lus',
            status: 'correct',
            total: 1,
          },
          {
            correct: 1,
            feedback: 'Gordel 1 richt zich eerst naar boven.',
            messages: [],
            name: 'Naar boven richten',
            status: 'correct',
            total: 1,
          },
          {
            correct: 1,
            feedback: 'Gordel 1 neemt nadien 25 keer 1 stap.',
            messages: [],
            name: 'Stappen nemen',
            status: 'correct',
            total: 1,
          },
          {
            correct: 1,
            feedback: 'Gordel 1 richt zich daarna naar beneden.',
            messages: [],
            name: 'Naar beneden richten',
            status: 'correct',
            total: 1,
          },
          {
            correct: 1,
            feedback: 'Gordel 1 neemt nadien 25 keer 1 stap.',
            messages: [],
            name: 'Stappen nemen',
            status: 'correct',
            total: 1,
          },
        ],
      },
      {
        correct: 4,
        messages: [],
        name: 'Test voor Gordel 2',
        total: 5,
        visibility: 'show',
        children: [
          {
            correct: 0,
            feedback: 'Gordel 2 moet oneindig lang bewegen.',
            messages: [],
            name: 'Juiste lus',
            status: 'wrong',
            total: 1,
          },
          {
            correct: 1,
            feedback: 'Gordel 2 richt zich eerst naar boven.',
            messages: [],
            name: 'Naar boven richten',
            status: 'correct',
            total: 1,
          },
          {
            correct: 1,
            feedback: 'Gordel 2 neemt nadien 30 keer 1 stap.',
            messages: [],
            name: 'Stappen nemen',
            status: 'correct',
            total: 1,
          },
          {
            correct: 1,
            feedback: 'Gordel 2 richt zich daarna naar beneden.',
            messages: [],
            name: 'Naar beneden richten',
            status: 'correct',
            total: 1,
          },
          {
            correct: 1,
            feedback: 'Gordel 2 neemt nadien 30 keer 1 stap.',
            messages: [],
            name: 'Stappen nemen',
            status: 'correct',
            total: 1,
          },
        ],
      },
      {
        correct: 0,
        messages: [],
        name: 'Test voor Gordel 3',
        total: 5,
        visibility: 'show',
        children: [
          {
            correct: 0,
            feedback: 'Gordel 3 moet oneindig lang bewegen.',
            messages: [],
            name: 'Juiste lus',
            status: 'wrong',
            total: 1,
          },
          {
            correct: 0,
            feedback: 'Gordel 3 moet zich naar eerst beneden richten.',
            messages: [],
            name: 'Naar beneden richten',
            status: 'wrong',
            total: 1,
          },
          {
            correct: 0,
            feedback: 'Gordel 3 moet nadien 30 keer 1 stap nemen.',
            messages: [],
            name: 'Stappen nemen',
            status: 'wrong',
            total: 1,
          },
          {
            correct: 0,
            feedback: 'Gordel 3 moet zich naar daarna boven richten.',
            messages: [],
            name: 'Naar boven richten',
            status: 'wrong',
            total: 1,
          },
          {
            correct: 0,
            feedback: 'Gordel 3 moet nadien 30 keer 1 stap nemen.',
            messages: [],
            name: 'Stappen nemen',
            status: 'wrong',
            total: 1,
          },
        ],
      },
      {
        correct: 0,
        messages: [],
        name: 'Test voor Gordel 4',
        total: 5,
        visibility: 'show',
        children: [
          {
            correct: 0,
            feedback: 'Gordel 4 moet oneindig lang bewegen.',
            messages: [],
            name: 'Juiste lus',
            status: 'wrong',
            total: 1,
          },
          {
            correct: 0,
            feedback: 'Gordel 4 moet zich naar eerst beneden richten.',
            messages: [],
            name: 'Naar beneden richten',
            status: 'wrong',
            total: 1,
          },
          {
            correct: 0,
            feedback: 'Gordel 4 moet nadien 25 keer 1 stap nemen.',
            messages: [],
            name: 'Stappen nemen',
            status: 'wrong',
            total: 1,
          },
          {
            correct: 0,
            feedback: 'Gordel 4 moet zich naar daarna boven richten.',
            messages: [],
            name: 'Naar boven richten',
            status: 'wrong',
            total: 1,
          },
          {
            correct: 0,
            feedback: 'Gordel 4 moet nadien 25 keer 1 stap nemen.',
            messages: [],
            name: 'Stappen nemen',
            status: 'wrong',
            total: 1,
          },
        ],
      },
      {
        correct: 0,
        messages: [],
        name: 'Test voor Gordel 5',
        total: 5,
        visibility: 'show',
        children: [
          {
            correct: 0,
            feedback: 'Gordel 5 moet oneindig lang bewegen.',
            messages: [],
            name: 'Juiste lus',
            status: 'wrong',
            total: 1,
          },
          {
            correct: 0,
            feedback: 'Gordel 5 moet zich naar eerst beneden richten.',
            messages: [],
            name: 'Naar beneden richten',
            status: 'wrong',
            total: 1,
          },
          {
            correct: 0,
            feedback: 'Gordel 5 moet nadien 40 keer 1 stap nemen.',
            messages: [],
            name: 'Stappen nemen',
            status: 'wrong',
            total: 1,
          },
          {
            correct: 0,
            feedback: 'Gordel 5 moet zich naar daarna boven richten.',
            messages: [],
            name: 'Naar boven richten',
            status: 'wrong',
            total: 1,
          },
          {
            correct: 0,
            feedback: 'Gordel 5 moet nadien 40 keer 1 stap nemen.',
            messages: [],
            name: 'Stappen nemen',
            status: 'wrong',
            total: 1,
          },
        ],
      },
    ],
  },
];
